import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import WaitingModal from '../../generics/WaitingModal';
import swal from 'sweetalert';

var Config = require('../../../config')

class Traceability extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);

		this.state = {
			unit_list:[],
			unit_number:"",
			type_list:[],
			type:"",
			unit_id:"",
			donation:"",
			columns:[]
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=UNIT_TRACEABILITY',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	});
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
    		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)

    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
	      		
		}
  	}

  	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	validateSearch(){
		var valid = true;

		if(this.state.unit_number === ""){
			document.getElementById('unit_number').classList.add('error');
			valid = false;
		}else{
			document.getElementById('unit_number').classList.remove('error');
		}

		return valid;
	}

	onSearch(){
		if(this.validateSearch()){
			//this.setState({donation:this.state.unit_number});

			this.waiting_modal.handleShow('Cargando...');

			setTimeout(function(){
				fetch(Config.default.apiGateway.URL+'logs/traceability?health_facilities_id='+
					sessionStorage.getItem('health_facilities_id')+'&unit_number='+this.state.unit_number,{
					method: 'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.json();
					}else{
						this.setState({unit_list:[], donation:""});
						res.text().then(function(msg){
							swal("Error", 'Unidad no encontrada', 'error');
						});
						
					}
				}).then(response => {
					if(response !== undefined){
						
						const bubbleSort = arr => {
						    const l = arr.length;
						    for (let i = 0; i < l; i++ ) {
						        for (let j = 0; j < l - 1 - i; j++ ) {
						        	if(arr[j].data !== null){
						        		if(arr[j+1].data !== null){
						        			if ( arr[j].data.transaction.timestamp > arr[j + 1].data.transaction.timestamp ) {
								                [ arr[j], arr[j + 1]] = [ arr[j + 1], arr[j] ];
								            }
						        		}else{
						        			 [ arr[j], arr[j + 1]] = [ arr[j + 1], arr[j] ];							        		
						        		}
						        	}
							            
						        }
						    }

						    return arr;
						}

						const result = bubbleSort(response);

						this.setState({
							donation:this.state.unit_number,
							unit_list:result,
							unit_number:""
						});
					}
				})
			}.bind(this), 500);
		}else{
			swal("Error", "Campos requeridos", 'error');
		}
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						{t('sidebar.nav.warehouse.traceability')}
					</h5>
				</div>

				<form noValidate>
					<div className="col-xs-12">
						<fieldset>
							<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-2">
									<label>No. Unidad</label>
									<input type="text" name="unit_number" id="unit_number" className="form-control" value={this.state.unit_number || ""} 
										onChange={this.handleChange} required onKeyPress={(e) => this.validateInput(e)} />
								</div>
					
								<div className="col-xs-12 col-sm-1"style={{paddingTop:"17px"}}>
				        			<button style={{fontSize:"1em"}} className="btn btn-info" 
				        				type="button" onClick={this.onSearch} >
				        				{t('content.generics.buttons.search')}
				        			</button>
								</div>
							</div>						
						</fieldset>	
					</div>

					<hr style={{width:"90%"}} />
					<div className="col-xs-12 form-group">
						<label className="color-font" style={{fontSize:"1.5em", fontWeight: "normal"}}>Unidad: {this.state.donation}</label>	
					</div>
					<div className="col-xs-12">
						
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('DATE')}>Fecha - Hora</th>
									<th hidden={this.showColumn('ACTION')}>Acción</th>
									<th hidden={this.showColumn('INCIDENT')}>Incidencia</th>
									<th hidden={this.showColumn('USER')}>Usuario</th>
									<th hidden={this.showColumn('IP')}>IP</th>
								</tr>
							</thead>
							<tbody>
								{this.state.unit_list.map((u, i)=>{
									return <tr key={i}>
										<td hidden={this.showColumn('DATE')}>{u.data !== null ? moment(u.data.transaction.timestamp).format('DD/MM/YYYY H:mm') : null }</td>
										<td hidden={this.showColumn('ACTION')}>{u.action !== null ? 
												u.action 
											: ""}
										</td>
										<td hidden={this.showColumn('INCIDENT')}>{u.incident !== null ? u.incident : ""}</td>
										<td hidden={this.showColumn('USER')}>{u.data !== null ? u.data.user : null}</td>
										<td hidden={this.showColumn('IP')}>{u.data !== null ? u.data.transaction.ip_address : null}</td>
									</tr>
								
								})}

							</tbody>
						</Table>
					</div>
				</form>

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
			</div>
		)
	}
}

export default translate('translations')(Traceability);